import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgThumbUp = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "M5.749 8.75h-.8c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874c-.218.428-.218.988-.218 2.108v3.1c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874c.427.218.987.218 2.108.218h.8m0-9.5h.043c.432 0 .649 0 .83-.074a1 1 0 0 0 .409-.308c.12-.154.18-.362.3-.778l1.46-5.116a.998.998 0 0 1 .96-.724c1.104 0 1.998.894 1.998 1.997V6.15c0 .56 0 .84.108 1.054a1 1 0 0 0 .438.437c.213.109.494.109 1.053.109h1.33c1.44 0 2.156 0 2.64.3.425.263.744.674.88 1.154.156.548-.054 1.24-.45 2.625l-1.17 4.1c-.237.832-.357 1.248-.6 1.557a1.98 1.98 0 0 1-.81.616c-.363.148-.794.148-1.66.148h-7.76m0-9.5v9.5"
	})]
});
const ForwardRef = forwardRef(SvgThumbUp);
export { ForwardRef as ReactComponent };
